module.exports = __webpack_public_path__ + "img/loan-amount-icon.3560bb0c.svg";